import { render, staticRenderFns } from "./multiple_accepting_order_items_field.vue?vue&type=template&id=1c749f46&lang=pug&"
import script from "./multiple_accepting_order_items_field.vue?vue&type=script&lang=js&"
export * from "./multiple_accepting_order_items_field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports